<!-- 空结果 -->
<template>
  <div :class="$style.privacyPolicy">
    <div :class="$style.privacyPolicyTitle">
      <van-icon
        style="cursor: pointer"
        name="arrow-left"
        color="white"
        size="20"
        @click="$emit('close')"
      />
      <p data-title>隐私条款</p>
      <van-icon name="arrow-left" color="white" size="20" style="opacity: 0" />
    </div>
    <div :class="$style.privacyPolicyIframe">
      <iframe src="/iframe/privacyPolicy0706.html" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "privacy-policy",
};
</script>

<style lang="scss" module>
@import "@/assets/themes.scss";
.privacyPolicy {
  padding: 24px 16px;
  height: 100%;
  background-color: #0d0b1d;
  padding-top: 66px;
  z-index: 100;
  position: fixed;
  left: 0;
  width: 100%;
}
.privacyPolicyTitle {
  display: flex;
  justify-content: space-between;
  height: 46px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 24px 16px 0 16px;
  [data-title] {
    font-size: 18px;
    font-family: MicrosoftYaHeiUI;
    color: #6555ff;
    line-height: 24px;
  }
}

.privacyPolicyIframe {
  position: relative;
  height: 100%;
  width: 100%;
  iframe {
    background-color: transparent;
    width: 100%;
    height: 100%;
  }
}
</style>
